module.exports = __webpack_public_path__ + "static/media/message.ffcf88df.png";